export const app_version:string = '2.2590';

// npm run start:fast



// export NODE_OPTIONS=--max_old_space_size=8192
// export NODE_OPTIONS=--max_old_space_size=16384